/* eslint-disable @angular-eslint/directive-selector */
import { Directive, HostBinding, Input } from '@angular/core';
import { v4 as newGuid } from 'uuid';

/**
 * Simple directive that appends the id attribute into the host element
 * If no params provided, it appends a new Guid
 *
 * @export
 * @class IdOrDefaultDirective
 */
@Directive({ selector: '[idOrDefault]' })
export class IdOrDefaultDirective {
  private defaultId = newGuid();
  private hostId!: string;

  /**
   * Input that defined the host Id attribute
   * If null or undefined is provided, it uses a new unique id
   *
   * @type {string}
   * @memberof IdOrDefaultDirective
   */
  @Input()
  set idOrDefault(value: string) {
    this.hostId = value || this.defaultId;
  }

  /**
   * Bind the provided id with the Id attribute of the host element
   *
   * @readonly
   * @type {string}
   * @memberof IdOrDefaultDirective
   */
  @HostBinding('id') get id(): string {
    return this.hostId;
  }
}
